/**
 * PdpBuyRow — AJAX add to cart with Adding/Added states, OOS toggle.
 */
class PdpBuyRow extends HTMLElement {
  connectedCallback() {
    this.submitBtn = this.querySelector('.pdp-buy-row__submit');
    this.submitBtnText = this.submitBtn && this.submitBtn.querySelector('span');
    this.oosBtn = this.querySelector('.pdp-buy-row__oos-btn');
    this.quantityInput = this.querySelector('.pdp-buy-row__quantity-input');
    this.form = this.querySelector('.pdp-buy-row__form');

    this.variantChangeUnsubscriber = subscribe(
      PUB_SUB_EVENTS.variantChange,
      this.handleVariantChange.bind(this)
    );

    if (this.form) {
      this.form.addEventListener('submit', this.handleSubmit.bind(this));
    }

    this.updateState(this.dataset.initialAvailable !== 'true');
  }

  disconnectedCallback() {
    if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
  }

  handleVariantChange(event) {
    const variant = event.data?.variant;
    if (!variant) return;
    this.updateState(!variant.available);
  }

  handleSubmit(evt) {
    evt.preventDefault();
    if (!this.submitBtn || this.submitBtn.disabled) return;

    this.setSubmitState('adding');

    const formData = new FormData(this.form);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status) {
          this.setSubmitState('error', data.description || 'Could not add item');
          return;
        }
        this.setSubmitState('added');
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'pdp-buy-row',
          productVariantId: formData.get('id'),
          cartData: data,
        });
        clearTimeout(this.resetTimer);
        this.resetTimer = setTimeout(() => this.setSubmitState('idle'), 2000);
      })
      .catch(() => {
        this.setSubmitState('error', 'Something went wrong');
      });
  }

  setSubmitState(state, errorMsg) {
    if (!this.submitBtn) return;
    const labels = { idle: 'Add to cart', adding: 'Adding...', added: 'Added!', error: errorMsg || 'Error' };
    if (this.submitBtnText) this.submitBtnText.textContent = labels[state];
    this.submitBtn.disabled = state === 'adding';
    this.submitBtn.classList.toggle('loading', state === 'adding');
    if (state === 'error') {
      clearTimeout(this.resetTimer);
      this.resetTimer = setTimeout(() => this.setSubmitState('idle'), 2500);
    }
  }

  updateState(isOos) {
    if (this.submitBtn) {
      if (isOos) {
        this.submitBtn.classList.add('hidden');
        this.submitBtn.disabled = true;
      } else {
        this.submitBtn.classList.remove('hidden');
        this.submitBtn.disabled = false;
        this.setSubmitState('idle');
      }
    }

    if (this.oosBtn) {
      this.oosBtn.classList.toggle('hidden', !isOos);
    }

    if (this.quantityInput) {
      this.quantityInput.dataset.disabled = isOos ? 'true' : 'false';
      const qtyField = this.quantityInput.querySelector('.pdp-buy-row__qty-input');
      const qtyButtons = this.quantityInput.querySelectorAll('.pdp-buy-row__qty-btn');
      if (qtyField) qtyField.disabled = isOos;
      qtyButtons.forEach((btn) => { btn.disabled = isOos; });
    }
  }
}

customElements.define('pdp-buy-row', PdpBuyRow);
